export default __webpack_public_path__ + "static/media/GuyAnimation11.b61d667a.svg";